<template>
	<div class="all">
		<section class="notice">
			<div class="leftNotice">
				<ul>
					<li @click="noticeClick" :class="title == 1 ? 'selected' : 'unSelected'">
						<span>
							<img src="../../assets/icon/notice.png" alt="">
						</span>
						<span>公告</span>
					</li>
					<li @click="messageClick" :class="title == 2 ? 'selected' : 'unSelected'">
						<span>
							<img src="../../assets/icon/mess.png" alt="">
						</span>
						<span>通知</span>
					</li>

				</ul>
			</div>
			<div class="rightNotice">
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="未读" name="first"></el-tab-pane>
					<el-tab-pane label="已读" name="second"></el-tab-pane>
				</el-tabs>
				<section>
					<el-timeline v-if="formData.length > 0">
						<el-timeline-item v-for="(item, index) in formData" :timestamp="item.createTime.split('T')[0]"
							placement="top" style="cursor: pointer;">
							<el-card>
								<div @click="handleEdit(index, item)">
									<div style="display:flex;justify-content: space-between;">
										<div>
											<h3>{{ item.title }}</h3>
											<!-- <p v-html="item.content" style="white-space: nowrap;text-overflow: ellipsis;"></p> -->
											<p style="color: #6d6d6d;height: 35px;line-height: 35px;">
												{{ item.sendName }}{{ item.days == 0 ? '今天' : item.days + '天前' }}发布</p>
										</div>
										<div>
											<el-button v-if="item.url" type="primary" size="small"
												@click.stop="goRouter(item.url)">去处理</el-button>
										</div>
									</div>


								</div>

							</el-card>
						</el-timeline-item>
					</el-timeline>
					<div v-else style="text-align: center;">
						<p><img src="../../assets/icon/noData.png" alt="" style=""></p>
						<p style="margin-top: -30px;color:#666666;">暂无数据</p>
					</div>
				</section>

			</div>
		</section>


		<el-dialog title="" :visible.sync="isChildShow" :close-on-click-modal="false"  :modal-append-to-body="false">
			<el-form :model="receiveItems" label-width="75px">
				<el-form-item label="标题">
					<p style="border: 1px solid #DCDFE6;padding: 10px;border-radius: 5px;">{{ receiveItems.title }}</p>
				</el-form-item>
				<el-form-item label="消息内容">
					<p v-html="receiveItems.content" style="border: 1px solid #DCDFE6;padding: 10px;border-radius: 5px;">
					</p>
				</el-form-item>
				<el-form-item label="文件">
					<el-upload multiple action="/api/admin/bdContract/uploadContract" :on-preview="uploadDown"
						:headers="headers" :file-list="files" name="file" disabled>
					</el-upload>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" size="small" @click="readTrue">确 定</el-button>
				<el-button v-if="receiveItems.url" type="primary" size="small"
					@click="goRouter(receiveItems.url)">去处理</el-button>
			</span>
		</el-dialog>


		<el-dialog title="提示" :visible.sync="dialogVisible" width="25%" :close-on-click-modal="false"
			 :modal-append-to-body="false">
			<span>确定下载该文件吗？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmDownload">确定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
import downloadFile from '../../assets/js/downloadFile.js'
import navcon from '../../components/navcon.vue'

export default {
	data() {
		return {
			headers: {
				Authorization: localStorage.access_token
			},
			isChildShow: false,
			activeName: 'first',
			formline: {
				currentPage: 1,
				pageSize: 10,
				status: 1
			},
			files: [],
			receiveItems: [],
			formData: [],
			totalNum: null,
			dialogVisible: false,
			obj: null,

			title: "2",
			selected: 1,
		}
	},

	watch: {
		title() {
			this.getMessage();
		},
	},

	mounted() {
		this.getMessage();
	},

	methods: {
		goRouter(url) {
			console.log("this.receiveItems.url", url)
			this.$router.push(url);
		},
		readTrue() {
			this.isChildShow = false;
		},
		uploadDown(obj) {
			this.dialogVisible = true;
			this.obj = obj;
		},
		confirmDownload() {
			this.dialogVisible = false;
			downloadFile(this.obj);
		},


		handleClose() {
			this.$emit("isClose")
		},
		handleCurrentChange(num) { //当前页面变更
			this.formInline.currentPage = num;
		},
		handleClick(tab, event) {
			this.activeName == event.name
			this.getMessage();
		},
		// 查看
		handleEdit(a, b) {
			console.log(b)
			this.isChildShow = true
			this.receiveItems = b
			if (this.receiveItems.files != null) {
				let newFiles = [];
				this.receiveItems.files.forEach((item) => {
					newFiles.push({
						name: item.name,
						url: item.url
					});
				})
				this.files = newFiles;
			}

			this.read(b.id);
		},
		noticeClick() {
			this.title = 1;
			this.getMessage();
		},
		messageClick() {
			this.title = 2;
			this.getMessage();
		},


		// 消息、公告
		getMessage() {
			let url;
			console.log(this.title);
			if (this.title == 2) {
				url = "/api/message/queryReceiverMessage";
			} else {
				url = "/api/notice/app/queryReceiverNotice";
			}
			if (this.activeName == "first") {
				this.formline.status = '1';
			} else {
				this.formline.status = '2';
			}
			this.$http.post(url, {
				...this.formline
			}).then(res => {
				if (res.data.code == 0 && res.data.data) {
					this.formData = res.data.data.items
					this.totalNum = res.data.data.totalNum
				} else {
					this.formData = []
					this.totalNum = 0
				}
				console.log(res)
			}).catch(err => {
				console.log(err)
			})
		},


		// 阅读消息、公告
		read(id) {
			let url;
			console.log(this.title);
			if (this.title == 2) {
				url = "/api/message/readMessage";
			} else {
				url = "/api/notice/readWebNotice";
			}
			this.$http.get(url + `?id=${id}`).then(res => {
				this.getMessage();
				this.$parent.$parent.$parent.$parent.$parent.$parent.getSum()
			})
		},
	}
}
</script>

<style scoped="scoped">
.all {
	margin-top: 40px;

}

.notice {
	width: 100%;
	display: flex;
}

.notice .leftNotice {
	width: 18%;
	border-right: 2px solid #d5d5d5;
}

.notice .rightNotice {
	width: 82%;
}

.notice .rightNotice section {
	padding: 10px 20px 10px 20px;
}

.notice .leftNotice ul {}


.notice .leftNotice ul li {
	padding-left: 20px;
	height: 50px;
	line-height: 50px;
	text-align: left;
	position: relative;
	cursor: pointer;
	color: #000000;
}

.notice .leftNotice ul li img {
	width: 25px;
	height: 25px;
	position: relative;
	top: 5px;
}

.notice .leftNotice ul li span:nth-of-type(2) {
	margin-left: 10px;
}


.selected {
	background-color: #cee7fe;
	opacity: 0.5;
	color: #3C98FF;
}

.unSelected {
	background-color: none;
	color: #000;
}

.notice .leftNotice ul li:hover {
	color: #3C98FF;
}

>>>.el-card {
	width: 80%;
}

>>>#tab-first {
	margin-left: 10px;
}

>>>.el-tabs__active-bar {
	width: 45px !important;
}
</style>
